<template>
	<div class="cenNav">
		<div class="cenNavBox">
			<div class="swiper-nav">
				<div class="swiper-wrapper">
					<div class="swiper-slide swiper-slide-Two" v-for="(item,index) in list" :key="index" :style="{
							width:!item.name?'0':'auto'
						}">
						<!-- <div style="width: 200px;">
							{{item.name}}
						</div> -->
						<div class="cenNavBoxFor" @click.stop="goScroll(item,index)" :class="current==index?'xz':'wxz'"
							:style="{
							width:!item.name?'0':'auto'
						}">
							{{item.name}}
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="cenNavBoxFor" v-for="(item,index) in list" :key="index" @click="goScroll(item,index)" :class="current==index?'xz':'wxz'" :style="{
				width:!item.name?'0':'auto'
			}">
				{{item.name}}
			</div> -->
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		// props:{
		// 	list:{
		// 		typeof:Array,
		// 		default:[]
		// 	},
		// },
		data() {
			return {
				current: 0,
				list: [
					// {
					// 	name:'1aaaaaaaaaaaaaaaaacc'
					// },
					// {
					// 	name:'2aaaaaaaaaaaaaaaaacc'
					// },{
					// 	name:'3aaaaaaaaaaaaaaaaacc'
					// },{
					// 	name:'4aaaaaaaaaaaaaaaaacc'
					// },{
					// 	name:'5aaaaaaaaaaaaaaaaacc'
					// },{
					// 	name:'6aaaaaaaaaaaaaaaaacc'
					// },{
					// 	name:'7aaaaaaaaaaaaaaaaacc'
					// },{
					// 	name:'8aaaaaaaaaaaaaaaaacc'
					// },{
					// 	name:'9aaaaaaaaaaaaaaaaacc'
					// },{
					// 	name:'10aaaaaaaaaaaaaaaaacc'
					// },{
					// 	name:'11aaaaaaaaaaaaaaaaacc'
					// },{
					// 	name:'12aaaaaaaaaaaaaaaaacc'
					// },{
					// 	name:'13aaaaaaaaaaaaaaaaacc'
					// },{
					// 	name:'14aaaaaaaaaaaaaaaaacc'
					// },{
					// 	name:'15aaaaaaaaaaaaaaaaacc'
					// },{
					// 	name:'16aaaaaaaaaaaaaaaaacc'
					// },{
					// 	name:'17aaaaaaaaaaaaaaaaacc'
					// },{
					// 	name:'18aaaaaaaaaaaaaaaaacc'
					// },
				]
			}
		},
		mounted() {
			let t = this;
			// const mySwiper = new this.$swiper('.swiper-nav', {
			// 	// 方向
			// 	direction: 'horizontal',
			// 	// 自动播放
			// 	autoplay:false,
			// 	slidesPerView: 3, // 每屏显示3个滑块
			// 	slidesPerGroup: 1, // 每次滑动3个滑块
			// 	 freeMode: true,
			// });
		},
		methods: {
			goScroll(e, a) {
				console.log(e,a)
				// document.documentElement.scrollTop = 0
				this.$emit('goScroll', e.value, a)
			},
			setList(e) {
				this.list = e;
				console.log(this.list)
				let t = this;
				// setTimeout(function(){
				// 	const mySwiperTwo = new t.$swiper('.swiper-canpina', {
				// 			// 方向
				// 			direction: 'horizontal',
				// 			// 自动播放
				// 			autoplay: false,
				// 		});
				// },500)
				this.$nextTick(function(){
					// const mySwiperTwo = new t.$swiper('.swiper-canpina', {
					// 	// 方向
					// 	direction: 'horizontal',
					// 	// 自动播放
					// 	autoplay: false,
					// 	 freeMode: true,
					// 	observer: true,//修改swiper自己或子元素时，自动初始化swiper
					// 	observeParents: true//修改swiper的父元素时，自动初始化swiper
					// });
					const mySwiper = new this.$swiper('.swiper-nav', {
						// 方向
						direction: 'horizontal',
						// 自动播放
						autoplay:false,
						slidesPerView:'auto', // 每屏显示3个滑块
						slidesPerGroup: 1, // 每次滑动3个滑块
						 freeMode: true,
					});
				})
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.swiper-nav {
		width: 1200px;
		overflow: hidden;
		// height:50px;
		.swiper-slide{
			width:auto;
		}
		.swiper-slide-Two{
			// width: 500px ;
		}
	}
	.cenNav {
		position: sticky;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 999;
		margin-bottom: 149px;
		height: 56px;
		background-color: #fff;
		border-bottom: 1px solid #E5E5E5;
		display: flex;
		align-items: center;

		.cenNavBox {
			width: 1200px;
			margin: 0 auto;
			display: flex;
			align-items: center;

			// overflow-x: auto;
			

			.cenNavBoxFor {
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #000000;
				margin-right: 60px;
				cursor: pointer;
				white-space: nowrap;
			}

			.xz {
				font-weight: bold;
			}

			.wxz {
				font-weight: 300;
			}
		}
	}
	@media screen and (max-width:1200px) {
		.swiper-nav{
			width: 100% !important;
		}
		.cenNav{
			margin-bottom: 30px !important;
			padding:0 30px !important;
			box-sizing: border-box;
			.cenNavBox{
				width: 100% !important;
				.cenNavBoxFor {	
					margin-right: 30px !important;
				}
			}
		}
		
	}
</style>